"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlattarController = exports.ControllerState = void 0;
const plattar_api_1 = require("@plattar/plattar-api");
var ControllerState;
(function (ControllerState) {
    ControllerState[ControllerState["None"] = 0] = "None";
    ControllerState[ControllerState["Renderer"] = 1] = "Renderer";
    ControllerState[ControllerState["QRCode"] = 2] = "QRCode";
})(ControllerState = exports.ControllerState || (exports.ControllerState = {}));
/**
 * All Plattar Controllers are derived from the same interface
 */
class PlattarController {
    /**
     * Default QR Code rendering options
     */
    _GetDefaultQROptions() {
        return {
            color: this.getAttribute("qr-color") || "#101721",
            qrType: this.getAttribute("qr-style") || "default",
            shorten: this.getAttribute("qr-shorten") || true,
            margin: 0
        };
    }
    ;
    constructor(parent) {
        this._state = ControllerState.None;
        this._element = null;
        this._prevQROpt = null;
        this._parent = parent;
    }
    /**
     * Initialise and start AR mode if available
     */
    startAR() {
        return new Promise((accept, reject) => {
            this.initAR().then((launcher) => {
                launcher.start();
                accept();
            }).catch(reject);
        });
    }
    /**
     * Decide which QR Code to render according to the qr-type attribute
     * @param options
     * @returns
     */
    startQRCode(options) {
        const qrType = this.getAttribute("qr-type") || "viewer";
        switch (qrType.toLowerCase()) {
            case "ar":
                return this.startARQRCode(options);
            case "viewer":
            default:
                return this.startViewerQRCode(options);
        }
    }
    /**
     * Displays a QR Code that sends the user direct to AR
     * @param options
     * @returns
     */
    startARQRCode(options) {
        return new Promise((accept, reject) => {
            // remove the old renderer instance if any
            this.removeRenderer();
            const opt = options || this._GetDefaultQROptions();
            const viewer = document.createElement("plattar-qrcode");
            // required attributes with defaults for plattar-viewer node
            const width = this.getAttribute("width") || "500px";
            const height = this.getAttribute("height") || "500px";
            viewer.setAttribute("width", width);
            viewer.setAttribute("height", height);
            if (opt.color) {
                viewer.setAttribute("color", opt.color);
            }
            if (opt.margin) {
                viewer.setAttribute("margin", "" + opt.margin);
            }
            if (opt.qrType) {
                viewer.setAttribute("qr-type", opt.qrType);
            }
            viewer.setAttribute("shorten", (opt.shorten && (opt.shorten === true || opt.shorten === "true")) ? "true" : "false");
            const qrOptions = btoa(JSON.stringify(opt));
            let dst = plattar_api_1.Server.location().base + "renderer/launcher.html?qr_options=" + qrOptions;
            const sceneID = this.getAttribute("scene-id");
            const configState = this.getAttribute("config-state");
            const embedType = this.getAttribute("embed-type");
            const productID = this.getAttribute("product-id");
            const sceneProductID = this.getAttribute("scene-product-id");
            const variationID = this.getAttribute("variation-id");
            const variationSKU = this.getAttribute("variation-sku");
            const arMode = this.getAttribute("ar-mode");
            if (configState) {
                dst += "&config_state=" + configState;
            }
            if (embedType) {
                dst += "&embed_type=" + embedType;
            }
            if (productID) {
                dst += "&product_id=" + productID;
            }
            if (sceneProductID) {
                dst += "&scene_product_id=" + sceneProductID;
            }
            if (variationID) {
                dst += "&variation_id=" + variationID;
            }
            if (variationSKU) {
                dst += "&variation_sku=" + variationSKU;
            }
            if (arMode) {
                dst += "&ar_mode=" + arMode;
            }
            if (sceneID) {
                dst += "&scene_id=" + sceneID;
            }
            viewer.setAttribute("url", opt.url || dst);
            viewer.onload = () => {
                return accept(viewer);
            };
            this._element = viewer;
            this._state = ControllerState.QRCode;
            this._prevQROpt = opt;
            this.append(viewer);
        });
    }
    /**
     * Returns the Parent Instance
     */
    get parent() {
        return this._parent;
    }
    /**
     * Returns the specified attribute from the parent
     * @param attribute - The name of thhe attribute
     * @returns - The attribute value or null
     */
    getAttribute(attribute) {
        return this.parent ? (this.parent.hasAttribute(attribute) ? this.parent.getAttribute(attribute) : null) : null;
    }
    /**
     * Appends the provided element into the shadow-root of the parent element
     * @param element - The element to append
     */
    append(element) {
        const shadow = this.parent.shadowRoot || this.parent.attachShadow({ mode: 'open' });
        shadow.append(element);
    }
}
exports.PlattarController = PlattarController;
